<form class="comment-composer" (ngSubmit)="onSubmit()">
  @if (uploadErrorMessageKey(); as messageKey) {
    <div
      class="comment-composer__upload-banner"
      role="alert">
      <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      <span>{{ messageKey | translate }}</span>
      <button
        type="button"
        class="comment-composer__upload-banner-dismiss"
        [attr.aria-label]="'GENERAL.DISMISS' | translate"
        (click)="dismissUploadError()">
        <span class="sr-only">{{ 'GENERAL.DISMISS' | translate }}</span>
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
    </div>
  }

  <tf-rich-editor
    [bodyMarkdown]="body()"
    (bodyMarkdownChange)="body.set($event)"
    (attachmentIdsChange)="attachmentIds.set($event)"
    (submitShortcut)="onSubmit()"
    (uploadError)="onUploadError($event)"
    (pendingRemoved)="onPendingRemoved($event)"
    [placeholder]="(parentCommentId() ? 'COMMENTS.COMPOSER.REPLY_PLACEHOLDER' : 'COMMENTS.COMPOSER.PLACEHOLDER') | translate"
    [autofocus]="autofocus()"
    [ariaLabel]="(parentCommentId() ? 'COMMENTS.COMPOSER.REPLY_LABEL' : 'COMMENTS.COMPOSER.LABEL') | translate" />

  <div class="comment-composer__footer">
    <span
      class="comment-composer__counter"
      [class.comment-composer__counter--over]="isOverLimit()"
      aria-live="polite">
      {{ remaining() }}
    </span>

    <div class="comment-composer__actions">
      @if (showCancel()) {
        <p-button
          type="button"
          [label]="'GENERAL.CANCEL' | translate"
          severity="secondary"
          [text]="true"
          size="small"
          [disabled]="submitting()"
          (onClick)="onCancel()" />
      }
      <p-button
        type="submit"
        [label]="(parentCommentId() ? 'COMMENTS.COMPOSER.REPLY_SUBMIT' : 'COMMENTS.COMPOSER.SUBMIT') | translate"
        icon="pi pi-send"
        size="small"
        [loading]="submitting()"
        [disabled]="!canSubmit()" />
    </div>
  </div>
</form>
